import * as React from 'react';
import { NavLink } from "react-router-dom";
import { Routes } from "../../../../utils/app-constants";
import { UserList } from "../../../../support/models/users/user-list";

interface IProps {
    user: UserList;
}

export const UserListRow = (props : IProps) => {

    const { user } = props;
    return <tr key={user.id}>
                <td>
                    <NavLink to={Routes.SUPPORT_USER_EDIT_WITH_ID.formattify(user.id)}>
                        {user.id}
                    </NavLink>
                </td>
                <td>
                    <NavLink to={Routes.SUPPORT_USER_EDIT_WITH_ID.formattify(user.id)}>
                        { user.firstName ? `${user.firstName} ${user.lastName}` : 'Pending Sign-In' }
                    </NavLink>
                </td>
                <td>{user.email}</td>
                <td>{user.permissionCount}</td>
            </tr>;
};
